import React from 'react';

interface DefaultAttributesProps {
  attributes: string[];
  name: string;
}

const DefaultAttributes: React.FC<DefaultAttributesProps> = ({ attributes, name }) => {
  return (
    <div
      style={{
        border: '1px solid #f0f0f0',
        padding: 16,
        marginTop: 24,
        marginBottom: 24,
        borderRadius: 4,
      }}
    >
      <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 14 }}>{name}</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {attributes.map((attr) => (
          <div
            key={attr}
            data-test-id={`${name}`}
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.06)',
              padding: '4px 8px',
              borderRadius: 4,
              fontSize: 14,
              color: 'rgba(119, 119, 119, 1)',
            }}
          >
            {attr}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultAttributes;
